var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"factorsData"},[(_vm.factorsData)?_c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3"}},_vm._l((_vm.factorsData),function(data,diking_id){return _c('b-tab',{key:diking_id,attrs:{"title":_vm.getDikingName(data[0].diking)}},_vm._l((data),function(factorInfo,index){return _c('b-card',{key:("factorInfo" + index),staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-' + diking_id + '-' + index),expression:"'accordion-' + diking_id + '-' + index"}],attrs:{"block":"","href":"#","variant":"info"}},[_vm._v(_vm._s(factorInfo.name)+" ("),(factorInfo.nums)?_c('span',{staticStyle:{"display":"inline","font-size":"unset"}},[_vm._v("Сценарии № "+_vm._s(factorInfo.nums.join(", ")))]):_c('span',{staticStyle:{"display":"inline","font-size":"unset"}},[_vm._v("Сценарий № "+_vm._s(factorInfo.num))]),_vm._v(". Вероятность: "),_c('span',{staticStyle:{"display":"inline"},domProps:{"innerHTML":_vm._s(_vm.toNormal(factorInfo.Q))}}),_vm._v(")")])],1),_c('b-collapse',{attrs:{"id":'accordion-' + diking_id + '-' + index,"visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[(factorInfo.factor == 1)?_c('div',[_c('highcharts',{attrs:{"options":{
                    series: [
                      { data: factorInfo.Y, name: 'Интенсивность теплового излучения пожара пролива, кВт/м2' } ],
                    title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                    yAxis: {
                      min: 0,
                      title: {
                        text: 'кВт/м2',
                      },
                    },
                    xAxis: {
                      minRange: 1,
                      tickmarkPlacement: 'on',
                      title: {
                        text: 'Расстояние, м.',
                      },
                    },
                  }}})],1):_vm._e(),(factorInfo.factor == 2)?_c('div',[_c('highcharts',{attrs:{"options":{
                    series: [{ data: factorInfo.P, name: 'Избыточное давление ΔP, кПа' }],
                    title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                    yAxis: {
                      min: 0,
                      title: {
                        text: 'кПа',
                      },
                    },
                    xAxis: {
                      minRange: 1,
                      tickmarkPlacement: 'on',
                      title: {
                        text: 'Расстояние, м.',
                      },
                    },
                  }}}),_c('highcharts',{attrs:{"options":{
                    series: [{ data: factorInfo.I, name: 'Импульс фазы сжатия I+, кПа×c' }],
                    title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                    yAxis: {
                      min: 0,
                      title: {
                        text: 'кПа×c',
                      },
                    },
                    xAxis: {
                      minRange: 1,
                      tickmarkPlacement: 'on',
                      title: {
                        text: 'Расстояние, м.',
                      },
                    },
                  }}})],1):_vm._e(),(factorInfo.factor == 3)?_c('div',[_c('h5',[_vm._v(_vm._s(factorInfo.name)+" (Сценарий № "+_vm._s(factorInfo.num)+")")]),_vm._v("\n                Радиус воздействия продуктов сгорания паровоздушного облака в случае воздействия пожара-вспышки:\n                "+_vm._s(factorInfo.Rf.toFixed(2))+" м.\n              ")]):_vm._e(),(factorInfo.factor == 4)?_c('div',[_c('highcharts',{attrs:{"options":{
                    series: [
                      { data: factorInfo.Y, name: 'Интенсивность теплового излучения огненного шара, кВт/м2' } ],
                    title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                    yAxis: {
                      min: 0,
                      title: {
                        text: 'кВт/м2',
                      },
                    },
                    xAxis: {
                      minRange: 1,
                      tickmarkPlacement: 'on',
                      title: {
                        text: 'Расстояние, м.',
                      },
                    },
                  }}})],1):_vm._e(),(factorInfo.factor == 5)?_c('div',[_c('h5',[_vm._v(_vm._s(factorInfo.name)+" (Сценарий № "+_vm._s(factorInfo.num)+")")]),_vm._v("\n                Размеры горизонтального факела при струйном горении:"),_c('br'),_vm._v("\n                Диаметр: "+_vm._s(factorInfo.D.toFixed(2))+" м."),_c('br'),_vm._v("\n                Длина: "+_vm._s(factorInfo.L.toFixed(2))+" м."),_c('br')]):_vm._e(),(factorInfo.factor == 6)?_c('div',[_c('highcharts',{attrs:{"options":{
                    series: [
                      { data: factorInfo.Y, name: 'Интенсивность теплового излучения вертикального факела, кВт/м2' } ],
                    title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                    yAxis: {
                      min: 0,
                      title: {
                        text: 'кВт/м2',
                      },
                    },
                    xAxis: {
                      minRange: 1,
                      tickmarkPlacement: 'on',
                      title: {
                        text: 'Расстояние, м.',
                      },
                    },
                  }}})],1):_vm._e(),(factorInfo.factor == 7)?_c('div',[_c('highcharts',{attrs:{"options":{
                    series: [{ data: factorInfo.P, name: 'Избыточное давление ΔP, кПа' }],
                    title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                    yAxis: {
                      min: 0,
                      title: {
                        text: 'кПа',
                      },
                    },
                    xAxis: {
                      minRange: 1,
                      tickmarkPlacement: 'on',
                      title: {
                        text: 'Расстояние, м.',
                      },
                    },
                  }}}),_c('highcharts',{attrs:{"options":{
                    series: [{ data: factorInfo.I, name: 'Импульс фазы сжатия I+, кПа×c' }],
                    title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                    yAxis: {
                      min: 0,
                      title: {
                        text: 'кПа×c',
                      },
                    },
                    xAxis: {
                      minRange: 1,
                      tickmarkPlacement: 'on',
                      title: {
                        text: 'Расстояние, м.',
                      },
                    },
                  }}})],1):_vm._e()])],1)],1)}),1)}),1)],1):_c('div',[_c('center',[_c('h3',[_vm._v("Обьект не рассчитан или во время загрузки возникли ошибки")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }